import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { useDispatch, useSelector } from 'react-redux';

import { getAllAvailableEquipment } from '../../redux/slices/equipmentsSlice';

import { FarmshareEquipmentCard } from './FarmshareEquipmentCard';

const FarmshareEquipmentGrid = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const filteredEquipments = useSelector((state) => state.equipments.filteredEquipments);
  const isLoading = useSelector((state) => state.equipments.loading);

  useEffect(() => {
    dispatch(getAllAvailableEquipment());
  }, [dispatch]);

  return (
    <>
      {isLoading ? (
        <div>{t('farmshareInProgress.equipmentGrid.loading')}</div>
      ) : (
        <div className="container mx-auto pb-10">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-x-4 gap-y-6 justify-items-center">
            {filteredEquipments.map((equipment, index) => (
              <FarmshareEquipmentCard key={index} equipment={equipment} />
            ))}
          </div>
        </div>
      )}
    </>
  );
};

export { FarmshareEquipmentGrid };
